export default "__VITE_ASSET__16bf48e0__"